import gql from "graphql-tag";
import {
  FRAGMENT_MEDIA_ITEM,
  FRAGMENT_NEIGHBORHOOD_DETAILS,
} from "./fragments.js";

export const GET_PLAN = gql`
  ${FRAGMENT_MEDIA_ITEM}
  ${FRAGMENT_NEIGHBORHOOD_DETAILS}
  query GetPlan($uri: ID!) {
    plan(id: $uri, idType: URI) {
      databaseId
      id
      title
      floorplanDetails {
        basePrice
        bathroomsMax
        bathroomsMin
        bedroomsMax
        bedroomsMin
        collection
        displayTitle
        eciIframe
        eciLink
        finishedSqrFt
        floorplanAddType
        garage
        garageMin
        garageType
        homeType
        hubspotValue
        mainSqrFt
        matterportTour
        matterportTourTitle
        matterportTour2
        matterportTour2Title
        pdfEPub
        eciLink
        type
        elevations {
          ...MediaItemFragment
        }
        galleryItems {
          image {
            ...MediaItemFragment
          }
        }
        neighborhood {
          ...NeighborhoodDetailsFragment
        }
        tabs {
          title
          image {
            ...MediaItemFragment
          }
        }
      }
      productStatus {
        enableSnipeLink
        fieldGroupName
        sectionId
        statusCustom
        statusMessage
      }
    }
    collectionFeatures
    plans(last: 500) {
      nodes {
        databaseId
        id
        title
        uri
        floorplanDetails {
          bathroomsMax
          bathroomsMin
          bedroomsMax
          bedroomsMin
          collection
          displayTitle
          finishedSqrFt
          mainSqrFt
          elevations {
            ...MediaItemFragment
          }
          features {
            feature
          }
          neighborhood {
            ... on Neighborhood {
              databaseId
              id
              slug
              title
            }
          }
        }
        productStatus {
          enableSnipeLink
          fieldGroupName
          sectionId
          statusCustom
          statusMessage
        }
      }
    }
  }
`;
